/**
 * Valeurs numériques d'un examen qui semblent fausses (faute de frappe probable).
 * On avertit sans bloquer : une valeur hors norme peut être réelle (décision du 2026-09-20).
 * Chaque message s'affiche sous le champ concerné.
 */
const TEMP_MIN = 0;
const TEMP_MAX = 45;
const SUITE = 'Vous pouvez enregistrer quand même.';

function nombre(v: any): number | null {
	if (v === null || v === undefined || String(v).trim() === '') {
		return null;
	}
	const n = Number(String(v).replace(',', '.'));
	return isNaN(n) ? null : n;
}

/** Message d'avertissement par champ (clé = nom du champ) ; objet vide = rien à signaler. */
export function avertissementsExamen(valeurs: any): { [champ: string]: string } {
	const messages: { [champ: string]: string } = {};
	const temp = nombre(valeurs.tempEau);
	if (temp !== null && (temp < TEMP_MIN || temp > TEMP_MAX)) {
		messages.tempEau = `Valeur inhabituelle : ${temp} °C (attendu ${TEMP_MIN} à ${TEMP_MAX} °C). ${SUITE}`;
	}
	const pm = nombre(valeurs.pm);
	if (pm !== null && pm <= 0) {
		messages.pm = `Valeur inhabituelle : ${pm} (attendu supérieur à 0). ${SUITE}`;
	}
	['mortaliteparjours', 'nbrJoursMortalite', 'totalMortalite'].forEach(champ => {
		const n = nombre(valeurs[champ]);
		if (n !== null && n < 0) {
			messages[champ] = `Valeur négative : ${n} (attendu 0 ou plus). ${SUITE}`;
		}
	});
	return messages;
}
